import React from 'react';
import { Chip } from '@mui/material';

import type { TimelineItem } from './HistoryDialog.types.ts';

type HealthCategorySectionProps = {
  item: TimelineItem;
};

export const HealthCategorySection: React.FC<HealthCategorySectionProps> = ({ item }) => {
  // Only show for custom steps that have a health category
  if (item.stepSnapshot.stepType !== 'CUSTOM_STEP' || !('healthCategoryId' in item) || !item.healthCategoryId) {
    return null;
  }

  return (
    <Chip
      label={item.healthCategoryId}
      size="small"
      variant="outlined"
      sx={{ fontSize: '0.75rem', textTransform: 'capitalize' }}
    />
  );
};
